var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCake(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "17px",
    height: "16px",
    viewBox: "0 0 17 16",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ICONS",
    transform: "translate(-144.000000, -126.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "cake-icn",
    transform: "translate(144.500000, 126.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.6908743,10.6842722 L1.33553403,10.6842722 C0.597938953,10.6842722 -2.25597319e-13,11.2822112 -2.25597319e-13,12.0198063 L-2.25597319e-13,15.2810328 C-2.25597319e-13,15.6498303 0.298969476,15.9487998 0.667767015,15.9487998 L15.3586414,15.9487998 C15.7274389,15.9487998 16.0264084,15.6498303 16.0264084,15.2810328 L16.0264084,12.0198063 C16.0264084,11.2822112 15.4284694,10.6842722 14.6908743,10.6842722 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.00330105,9.34873821 L14.0231073,9.34873821 C14.3919049,9.34873821 14.6908743,9.04976874 14.6908743,8.6809712 L14.6908743,6.67767015 C14.6908743,5.94007507 14.0929354,5.34213612 13.3553403,5.34213612 L2.67106806,5.34213612 C1.93347298,5.34213612 1.33553403,5.94007507 1.33553403,6.67767015 L1.33553403,8.6809712 C1.33553403,9.04976874 1.63450351,9.34873821 2.00330105,9.34873821 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.01320418,4.00660209 C8.75079926,4.00660209 9.34873821,3.40866314 9.34873821,2.67106806 C9.34873821,1.93652434 8.01320418,-5.68434189e-14 8.01320418,-5.68434189e-14 C8.01320418,-5.68434189e-14 6.67767015,1.93652434 6.67767015,2.67106806 C6.67767015,3.40866314 7.27560911,4.00660209 8.01320418,4.00660209 Z",
    id: "Path"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCake);
export default __webpack_public_path__ + "static/media/cake.48a9ef05.svg";
export { ForwardRef as ReactComponent };